// extracted by mini-css-extract-plugin
export default {"wrapper":"src-containers-elements-banks-bank-list-styles-wrapper-QnRam","list-wrapper":"src-containers-elements-banks-bank-list-styles-list-wrapper-NR1LZ"};